import { useEffect } from "react";
import { useSelector, useDispatch } from "../store/store";
import { authorizeActions, authorizeSelectors } from "../store/authorize";
import { useNavigate } from "react-router-dom";
import { useGuard } from "../Guard";
import { Avatar, Badge, Button, Dropdown, Typography } from "antd";
import { softColor } from "../utils/colors";
import Icon from "@ant-design/icons";
import { Icons } from "../assets/icons";
import { authLogout, getAvatar } from "../repository/auth.repository";
import BlankAvatar from "../assets/images/blank-avatar.svg";

export interface LoggedUserProps {}

function LoggedUser(props: LoggedUserProps) {
  const dispatch = useDispatch();
  const user = useSelector(authorizeSelectors.user);
  const navigate = useNavigate();
  const guard = useGuard();

  // Lifecycle

  useEffect(() => {
    getAvatar()
      .catch(() => BlankAvatar)
      .then((data) => {
        dispatch(authorizeActions.setUser({ ...user, avatarSrc: data } as any));
      });
  }, []);

  // Events

  function onMenuItem(e: { readonly key: string }): void {
    switch (e.key) {
      case "user-profile":
        navigate("user-profile", { replace: true });
        break;
      case "billing":
        navigate("billing", { replace: true });
        break;
      case "signOut":
        authLogout();
        guard.signOut();
        break;
    }
  }

  function getFullName() {
    if ([user?.firstName, user?.lastName].filter((f) => !!f).length) {
      return [user?.firstName, user?.lastName].join(" ");
    }

    return user?.userName ?? "";
  }

  const userName = getFullName();

  return (
    <Dropdown
      trigger={["click"]}
      overlayClassName={"min-w-64"}
      menu={{
        items: [
          {
            icon: (
              <Icon
                className="-ml-0.5 text-2xl"
                component={Icons.AssignmentIcon}
              />
            ),
            key: "user-profile",
            label: "Your Profile",
          },
          {
            icon: (
              <Icon className="-ml-0.5 text-2xl" component={Icons.LogoutIcon} />
            ),
            key: "signOut",
            label: "Sing Out",
          },
        ],
        onClick: onMenuItem,
      }}
    >
      <Button className="m-0 p-1" type={"text"} size={"large"}>
        <Badge color={guard.connected ? "green" : "red"} dot>
          <Avatar
            style={{
              backgroundColor: user?.avatarSrc
                ? "lightgray"
                : softColor((userName[0] ?? "").toUpperCase()),
            }}
            className="flex flex-col items-center justify-center text-lg font-bold"
            src={user?.avatarSrc}
          >
            {(userName[0] ?? "").toUpperCase()}
          </Avatar>
        </Badge>
        <Typography.Text className="max-w-72 whitespace-nowrap">
          {userName}
        </Typography.Text>
      </Button>
    </Dropdown>
  );
}

export default LoggedUser;
